import icAccess from '../../../assets/IconsMenuCard/ic-access.svg';
import icAnnouncements from '../../../assets/IconsMenuCard/ic-announcements.svg';
import icApprovalFlowBlack from '../../../assets/IconsMenuCard/ic-approval-flow-black.svg';
import icApprovalFlowPrimary from '../../../assets/IconsMenuCard/ic-approval-flow-primary.svg';
import icApprovalFlowWhite from '../../../assets/IconsMenuCard/ic-approval-flow-white.svg';
import icApprovalFlow from '../../../assets/IconsMenuCard/ic-approval-flow.svg';
import icAttendance from '../../../assets/IconsMenuCard/ic-attendance.svg';
import icBackUp from '../../../assets/IconsMenuCard/ic-back-up.svg';
import icCafeteria from '../../../assets/IconsMenuCard/ic-cafeteria.svg';
import icCardDesigner from '../../../assets/IconsMenuCard/ic-card-designer.svg';
import icCardManagment from '../../../assets/IconsMenuCard/ic-card-managment.svg';
import icCompany from '../../../assets/IconsMenuCard/ic-company.svg';
import icContractors from '../../../assets/IconsMenuCard/ic-contractors.svg';
import icController from '../../../assets/IconsMenuCard/ic-controller.svg';
import icDeleteRestore from '../../../assets/IconsMenuCard/ic-delete-restore.svg';
import icDepartments from '../../../assets/IconsMenuCard/ic-departments.svg';
import icDevices from '../../../assets/IconsMenuCard/ic-devices.svg';
import icDistributioCenter from '../../../assets/IconsMenuCard/ic-distributio-center.svg';
import icDocumentPanel from '../../../assets/IconsMenuCard/ic-document-panel.svg';
import icEmailServiceSettings from '../../../assets/IconsMenuCard/ic-email-service-settings.svg';
import icEmployees from '../../../assets/IconsMenuCard/ic-employees.svg';
import icEvents from '../../../assets/IconsMenuCard/ic-events.svg';
import icFirstAccess from '../../../assets/IconsMenuCard/ic-first-access.svg';
import icGraphs from '../../../assets/IconsMenuCard/ic-graphs.svg';
import icGuard from '../../../assets/IconsMenuCard/ic-guard.svg';
import icHomeOffice from '../../../assets/IconsMenuCard/ic-home-office.svg';
import icLogs from '../../../assets/IconsMenuCard/ic-logs.svg';
import icManager from '../../../assets/IconsMenuCard/ic-manager.svg';
import icOnBoarding from '../../../assets/IconsMenuCard/ic-on-boarding.svg';
import icPrivilageSettings from '../../../assets/IconsMenuCard/ic-privilage-settings.svg';
import icProfile from '../../../assets/IconsMenuCard/ic-profile.svg';
import icServiceType from '../../../assets/IconsMenuCard/ic-service-type.svg';
import icSupplier from '../../../assets/IconsMenuCard/ic-supplier.svg';
import icSystemSettings from '../../../assets/IconsMenuCard/ic-system-settings.svg';
import icTransportRequest from '../../../assets/IconsMenuCard/ic-transport-request.svg';
import icVehicleFleet from '../../../assets/IconsMenuCard/ic-vehicle-fleet.svg';
import icWorkshipPanel from '../../../assets/IconsMenuCard/ic-workship-panel.svg';
import icDiningManagement from '../../../assets/IconsMenuCard/ic-dining-management.svg'
import icVisitors from '../../../assets/IconsMenuCard/ic-visitors.svg';
import icVisitorManagment from '../../../assets/IconsMenuCard/ic-visitor-managment.svg';
import icKitchenTickets from '../../../assets/IconsSidebar/ic-kitchen-tickets.svg';
import icIncomingInvitation from '../../../assets/IconsMenuCard/ic-incoming-invitation.svg';
import icIncomingContractors from '../../../assets/IconsMenuCard/ic-incoming-contractors.svg';
import icTraffic from '../../../assets/IconsMenuCard/ic-traffic.svg';
import icCompanyDocumentation from '../../../assets/IconsMenuCard/ic-company-documentation.svg';
import icEquipmentMaterial from '../../../assets/IconsMenuCard/ic-equipment-material.svg';
import icDeliveredServices from '../../../assets/IconsTittles/ic-meal-time.svg';
import icMaterialRequest from '../../../assets/IconsSidebar/ic-material-request.svg';

export const IconsMenuCard = {
    icAccess,
    icAnnouncements,
    icApprovalFlowBlack,
    icApprovalFlowPrimary,
    icApprovalFlowWhite,
    icApprovalFlow,
    icAttendance,
    icBackUp,
    icCafeteria,
    icCardDesigner,
    icCardManagment,
    icCompany,
    icContractors,
    icController,
    icDeleteRestore,
    icDepartments,
    icDevices,
    icDistributioCenter,
    icDocumentPanel,
    icEmailServiceSettings,
    icEmployees,
    icEvents,
    icFirstAccess,
    icGraphs,
    icGuard,
    icHomeOffice,
    icLogs,
    icManager,
    icOnBoarding,
    icPrivilageSettings,
    icProfile,
    icServiceType,
    icSupplier,
    icSystemSettings,
    icTransportRequest,
    icVehicleFleet,
    icWorkshipPanel,
    icVisitorManagment,
    icVisitors,
    icKitchenTickets,
    icDiningManagement,
    icIncomingInvitation,
    icTraffic,
    icIncomingContractors,
    icCompanyDocumentation,
    icEquipmentMaterial,
    icDeliveredServices,
    icMaterialRequest
};


